export const env = window.appSettings;
export const appSettings = window.appSettings;